import { render, staticRenderFns } from "./examination_teamhome_manage.vue?vue&type=template&id=4fbc0f64&scoped=true"
import script from "./examination_teamhome_manage.vue?vue&type=script&lang=js"
export * from "./examination_teamhome_manage.vue?vue&type=script&lang=js"
import style0 from "./examination_teamhome_manage.vue?vue&type=style&index=0&id=4fbc0f64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc0f64",
  null
  
)

export default component.exports